import styled from 'styled-components';

import { colors } from 'theme/theme';
import { VideoData } from 'types/Video/VideoData';

export const VideoPlayerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const VideoPlayerIframe = styled.iframe<{
  $videoDataType: VideoData['type'];
}>`
  background: ${(props) =>
    props.$videoDataType === 'youtube'
      ? colors.black
      : colors.lightContentGrey};
  border: 0;
  aspect-ratio: 16 / 9;
  width: 100%;
  height: 100%;
`;

export const VideoPlayerVideo = styled.video`
  width: 100%;
  height: 100%;
`;
